// api/categories.ts
import { fetchAPI } from "./utils";
import {
    GetCategoriesParams,
    CreateCategoryParams,
    UpdateCategoryParams,
    DeleteCategoryParams,
} from "../types/requestInputs";
import {
    GetCategoriesResponse,
    CreateCategoryResponse,
    UpdateCategoryResponse,
    DeleteCategoryResponse,
} from "../types/requestsOutputs";

// Fetch all categories
export const getCategories = async ({ token, data }: GetCategoriesParams): Promise<GetCategoriesResponse> => {
    return fetchAPI<GetCategoriesResponse>("/get-categories", "POST", data, token);
};

// Create a new category
export const createCategory = async ({ token, payload }: CreateCategoryParams): Promise<CreateCategoryResponse> => {
    return fetchAPI<CreateCategoryResponse>("/create-category", "POST", payload, token);
};

// Update category
export const updateCategory = async ({ token, payload }: UpdateCategoryParams): Promise<UpdateCategoryResponse> => {
    return fetchAPI<UpdateCategoryResponse>("/update-category", "POST", payload, token);
};

// Delete a category
export const deleteCategory = async ({ token, categoryId }: DeleteCategoryParams): Promise<DeleteCategoryResponse> => {
    return fetchAPI<DeleteCategoryResponse>("/delete-category", "POST", { categoryId }, token);
};
